function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "password-img",
  transform: "translate(3 -1.001)"
}, React.createElement("g", {
  id: "Group_2366",
  "data-name": "Group 2366",
  transform: "translate(0 4.001)"
}, React.createElement("g", {
  id: "Group_2365",
  "data-name": "Group 2365",
  transform: "translate(0 0)"
}, React.createElement("circle", {
  id: "Ellipse_265",
  "data-name": "Ellipse 265",
  cx: 4.898,
  cy: 4.898,
  r: 4.898,
  transform: "translate(77.885 79.844)",
  fill: "#00bf6f",
  stroke: "#fff",
  strokeWidth: 3
}), React.createElement("path", {
  id: "Path_3580",
  "data-name": "Path 3580",
  d: "M58.291,115.6h-38.7a9.808,9.808,0,0,1-9.8-9.8V65.64a9.808,9.808,0,0,1,9.8-9.8H90.131a9.808,9.808,0,0,1,9.8,9.8v9.8a4.9,4.9,0,1,0,9.8,0v-9.8A19.616,19.616,0,0,0,90.131,46.046H84.244V28.771C84.244,12.907,71.059,0,54.853,0S25.463,12.907,25.463,28.771V46.046H19.594A19.616,19.616,0,0,0,0,65.64v40.167A19.616,19.616,0,0,0,19.594,125.4h38.7a4.9,4.9,0,1,0,0-9.8ZM35.26,28.771C35.26,18.309,44.049,9.8,54.853,9.8s19.594,8.511,19.594,18.973V46.046H35.26V28.771Z",
  transform: "translate(0 -0.001)",
  fill: "#403f50",
  stroke: "#fff",
  strokeWidth: 6
}), React.createElement("path", {
  id: "Path_3581",
  "data-name": "Path 3581",
  d: "M321.969,322.915a4.9,4.9,0,0,0-6.834,1.132L290.99,357.772a2.8,2.8,0,0,1-4.027.209l-15.6-15.227a4.9,4.9,0,1,0-6.842,7.011l15.631,15.254.044.042a12.629,12.629,0,0,0,8.689,3.472q.415,0,.831-.028a12.629,12.629,0,0,0,8.98-4.677q.085-.107.165-.217L323.1,329.749A4.9,4.9,0,0,0,321.969,322.915Z",
  transform: "translate(-198.616 -243.135)",
  fill: "#00bf6f",
  stroke: "#fff",
  strokeWidth: 4
}), React.createElement("circle", {
  id: "Ellipse_266",
  "data-name": "Ellipse 266",
  cx: 4.898,
  cy: 4.898,
  r: 4.898,
  transform: "translate(59.271 79.844)",
  fill: "#00bf6f",
  stroke: "#fff",
  strokeWidth: 3
}), React.createElement("circle", {
  id: "Ellipse_267",
  "data-name": "Ellipse 267",
  cx: 4.898,
  cy: 4.898,
  r: 4.898,
  transform: "translate(22.533 79.844)",
  fill: "#00bf6f",
  stroke: "#fff",
  strokeWidth: 3
}), React.createElement("circle", {
  id: "Ellipse_268",
  "data-name": "Ellipse 268",
  cx: 4.898,
  cy: 4.898,
  r: 4.898,
  transform: "translate(40.902 79.844)",
  fill: "#00bf6f",
  stroke: "#fff",
  strokeWidth: 3
}))));
var SvgPasswordImg = function SvgPasswordImg(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 130.41,
    height: 131.4,
    viewBox: "0 0 130.41 131.4",
    ref: svgRef
  }, props), _ref2);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPasswordImg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/password-img.aeb71789.svg";
export { ForwardRef as ReactComponent };